import * as React from "react"
import {useProductDetailsQuery} from "../../../../../hooks/useProductDetailsQuery";

export const ShortDescription = () => {
    const {model: {descriptions: {short}}} = useProductDetailsQuery();

    if (!short) return <></>;

    return <h3 className="fw-normal fs-5" dangerouslySetInnerHTML={{__html: short}}/>;
}